import {Box, Button, Stack, Typography} from '@mui/material';
import HospitalizationImg from 'presentation/assets/images/hospitalization.svg';
import {StyledCard} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks/useMediaQueries';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useNavigate} from 'react-router-dom';
import {MyHospitalizationFlowEnum} from 'presentation/constants';
import {SectionContainer} from '../SectionContainer';

const {title, subtitle, description} =
	translations['pt-br'].privateFlow.home.myHospitalizationAlert;
const {access} = translations['pt-br'].commons;

export function MyHospitalizationAlert() {
	const {isTablet} = useMediaQueries();
	const navigate = useNavigate();

	const handleGoToHomeHospitalization = () => {
		navigate(MyHospitalizationFlowEnum.HOME);
	};

	return (
		<Fragment>
			<SectionContainer
				showTitle
				title={title}
				titleMarginTop={0}
				titleMarginBottom={isTablet ? 2 : 1}>
				<StyledCard.Container>
					<Stack direction="row" gap={1} alignItems="center">
						<Stack flexGrow={1}>
							<Typography
								variant="subtitle1"
								lineHeight={1.2}
								color="primary"
								fontWeight={600}>
								{subtitle}
							</Typography>
							<Typography variant="body2" color="text.primary" mt={0.5}>
								{description}
							</Typography>
							<Button
								variant="contained"
								color="primary"
								sx={{mt: 1.5, alignSelf: 'flex-start'}}
								size="medium"
								onClick={handleGoToHomeHospitalization}
								data-test-id="hospitalization-access-button">
								{access}
							</Button>
						</Stack>
						<Box flexShrink={0}>
							<img src={HospitalizationImg} alt="Paciente internado" />
						</Box>
					</Stack>
				</StyledCard.Container>
			</SectionContainer>
		</Fragment>
	);
}
